import $ from 'jquery'
import { AjaxHelper } from '~/common/extensions/ajax_helpers'
import { NoticeManager } from './notice_manager'
import {
  checkedStatesIn,
  restoreChecked,
  cartPaymentCheckboxes,
} from '~/site/pages/cart/cart_payment_checkboxes'

const noticeManager = new NoticeManager()

// Site-side response handler. Routes the shared directives through AjaxHelper,
// then handles the site-specific ones (message, slide_up, trigger_event_on_document)
// that don't exist in AjaxHelper.
//
// Also toggles `body.performing-action` while processing — `site/behaviors/editor/draft_content.js`
// reads this class to suppress draft-saving while a response is being applied.
//
// @param {object} data - Response data.
// @param {object} [data.update]   - DOM updates mapping DOM IDs to new inner HTML.
// @param {object} [data.replace]  - DOM replacements mapping DOM IDs to new outer HTML.
// @param {string[]} [data.remove] - DOM IDs to remove.
// @param {string} [data.redirect] - Redirect location.
// @param {object} [data.message]  - Message: { status, text }.
export const processResponse = function (data, eventTarget) {
  $('body').addClass('performing-action')

  // Strip `error` before delegating: site responses (cart validation, payment-
  // gateway failures, etc.) use `error:` as a string the JS callback reads
  // directly (see processFormSubmission). AjaxHelper's `data.error` directive
  // would pop a window.alert(), which is wrong here — the inline error UI is
  // already rendered via `replace:`.
  // eslint-disable-next-line no-unused-vars
  const { error: _siteError, ...ajaxData } = data

  // #cart-payment is never replaced wholesale, only its innerHTML swapped (see doUpdate below),
  // so the same container reference is valid to re-query before and after. See
  // cart_payment_checkboxes.js for why (ENG-35182). Every cart response that can re-render
  // #cart-payment comes through here. The one site path that calls AjaxHelper.doUpdate itself,
  // processFormSubmission's use_ajax_helper branch, is only set by the account signup form, which
  // has no #cart-payment.
  const cartPayment = document.getElementById('cart-payment')
  const preservedCheckedStates = checkedStatesIn(
    cartPaymentCheckboxes(cartPayment)
  )

  AjaxHelper.doUpdate(ajaxData, eventTarget)

  restoreChecked(cartPaymentCheckboxes(cartPayment), preservedCheckedStates)

  if (data.slide_up != null) {
    for (const selector of Array.from(data.slide_up)) {
      $(
        selector.startsWith('.') || selector.startsWith('#')
          ? selector
          : `#${selector}`
      ).slideUp(function () {
        $(this).remove()
      })
    }
  }

  if (data.trigger_event_on_document != null) {
    for (const event of Array.from(data.trigger_event_on_document)) {
      $(document).trigger(event)
    }
  }

  if (data.message != null) {
    noticeManager.show(data.message.status, data.message.text)
  }

  $('body').removeClass('performing-action')
}
